export enum TeamsRecipientType {
  CHANNEL = 'channel',
  USER = 'user',
  TEAM = 'team',
  USER_STORED_IN_SALESFORCE_FIELD = 'user_stored_in_salesforce_field',
  CHANNEL_STORED_IN_SWEEP = 'channel_stored_in_sweep',
  CHANNEL_STORED_IN_SALESFORCE_FIELD = 'channel_stored_in_salesforce_field',
}

export interface TeamsRecipientInfo {
  label: string;
  id: string | string[];
  type: TeamsRecipientType;
}

export interface TeamsRecipientStruct {
  type: TeamsRecipientType;
  value?: string | { fieldIds: string[] };
  label?: string;
}

export interface TeamsWithInstallationStatus extends TeamsRecipientInfo {
  isSweepAppInstalled: boolean;
}
